
import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import { TimeSlotSelection } from '@/types/time-slots';
import TimeSelection from './components/TimeSelection.vue';
import PriceSummary from '@/pages/shared/CampaignWizard/components/PriceSummary.vue';
import IButton from '@/ui-components/IButton/IButton.vue';
import DatePickerInput from '@/ui-components/DatePickerInput/DatePickerInput.vue';
import ComingSoon from '@/ui-components/ComingSoon/ComingSoon.vue';
import WizardHeader from '../WizardHeader.vue';
import TextField from '@/ui-components/TextField/TextField.vue';
import { LocationData, LocationPrice } from '@/types/locations';
import { Action, Getter } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { UpdateTime } from '@/store/modules/campaign-wizard/types';
import { rules } from '@/validation-rules';
import moment from 'moment';
import { CampaignFrequency } from '@/types/campaigns';
import { calculateDefaultPromoDiscount } from '@/utils/promotions';
import { AuthorizedUser } from '@/types/users';
import { Discount } from '@/types/promotions';
import { getLocationPriceByFrequency } from '@/utils/locations';
import { formatWeekDuration } from '@/utils/text';
import { PublishedAdSpace } from '@/types/adspaces';

@Component({
  components: {
    PriceSummary,
    DatePickerInput,
    TextField,
    IButton,
    WizardHeader,
    ComingSoon,
    TimeSelection,
  },
})
export default class CampaignTime extends Vue {
  public valid = false;
  locationPrices = {} as Record<LocationData['ID'], LocationPrice>
  public TODAY = moment().add('days', 1).format('YYYY-MM-DD');
  public isLoadingDiscounts = false;

  public requiredRule = rules.required(this.$t('field_required').toString());

  public durationRules = [
    this.requiredRule,
  ];
  public startDateRules = [
    this.requiredRule,
    rules.minDate(this.TODAY, 'Please choose date after today'),
  ];

  public calendarIcon = '/assets/icons/calendar.svg';
  public discounts: Discount[] = [];

  @Getter('selectedLocations', { namespace: namespaces.CampaignWizardModule })
  public campaignWizardSelectedLocations!: LocationData[];

  @Getter('time', { namespace: namespaces.CampaignWizardModule })
  public campaignWizardSelectedTimeSlots!: TimeSlotSelection;

  @Getter('userInfo', { namespace: namespaces.AuthModule })
  public userInfo!: AuthorizedUser;

  @Action('updateTime', { namespace: namespaces.CampaignWizardModule })
  public updateTime!: UpdateTime;

  public get selectedFrequency() {
    return this.campaignWizardSelectedTimeSlots.frequency as CampaignFrequency;
  }

  public set selectedFrequency(frequency: CampaignFrequency) {
    this.updateTime({
      ...this.campaignWizardSelectedTimeSlots,
      frequency
    });
  }

  public get startDate() {
    return this.campaignWizardSelectedTimeSlots.startDate as string;
  }

  public set startDate(startDate: string) {
    this.updateTime({
      ...this.campaignWizardSelectedTimeSlots,
      startDate
    });
  }

  public get duration() {
    return this.campaignWizardSelectedTimeSlots.duration as number;
  }

  public set duration(duration: number) {
    this.updateTime({
      ...this.campaignWizardSelectedTimeSlots,
      duration
    });
    this.getDefaultPromotions(duration);
  }


public get durationOptions() {
  return Array.from({ length: 6 }, (_, index) => {
    const weekNumber = index + 1;
    return {
      value: weekNumber,
      text: formatWeekDuration(weekNumber)
    };
  });
}

  get isNextButtonDisabled() {
    return !this.valid || !this.startDate || !this.campaignWizardSelectedTimeSlots?.frequency
  }

  public timeOptions = 'fixed';

  @Emit('update:discounts')
  async getDefaultPromotions(duration: number) {
    this.isLoadingDiscounts = true;
    try {
      this.discounts = await calculateDefaultPromoDiscount(this.userInfo as AuthorizedUser, {
        startDate: new Date(),
        durationInWeeks: duration,
        frequency: this.selectedFrequency,
        adSpaces: this.campaignWizardSelectedLocations as unknown as PublishedAdSpace[],
      });
      return this.discounts;
    } finally {
      this.isLoadingDiscounts = false;
    }
  }

  public previousStep() {
    this.$emit('previous-step');
  }

  public nextStep() {
    this.$emit('next-step');
  }
  updatePrice(){
      const {
        frequency
      } = this.campaignWizardSelectedTimeSlots;
      this.locationPrices = this.campaignWizardSelectedLocations.reduce((selectedLocations,selectedLocation:LocationData)=>{
        return { ...selectedLocations,
          [selectedLocation.clusterId]: {
            BASE_PRICE: getLocationPriceByFrequency(selectedLocation, frequency)
          }
        }
      },{})
    }
  @Watch('campaignWizardSelectedTimeSlots.frequency')
  updatePriceOnFrequencyChanged(){
    this.updatePrice()
    this.duration && this.getDefaultPromotions(this.duration);
  }

  created() {
    this.updatePrice();
    if (this.duration) {
      this.getDefaultPromotions(this.duration);
    }
  }
}
